import React, {useEffect, useState} from 'react';
import './texts.css';
import {ReturnTextAndImg} from './CheckImg';

export default function Texts({texts = []}) {

    const [selectedTab, setSelectedTab] = useState(0)
    const [text, setText] = useState('')
    useEffect(() => {
        const textAndImage = ReturnTextAndImg(texts[selectedTab]?.text)
        setText(textAndImage)
    }, [selectedTab])

    const tabsJSX = texts?.map((item, i) =>
        <li onClick={() => setSelectedTab(i)}
            className={`nav-item ${i === selectedTab ? "nav-link active" : "nav-link"}`} key={item.title}>
            {item.title}
        </li>
    )

    return (
        <div style={{width: '60%', margin: '0  0 0 2%'}}>
            <ul id="nav-bar" className="nav nav-tabs"> {tabsJSX} </ul>
            {/*<div className="tab-content"> {text} </div>*/}
            <div className={'content-div'}>
                <div className={'content'}>{text}</div>
            </div>
        </div>
    );
}
